import Player from '@vimeo/player';

export default class ModalVideo {
  openModalButton;
  modalNode;
  modalInnerNode;
  backdropNode;
  closeIconNode;
  toggleModal;
  modalName;
  videoCode;
  vimeoPlayer;
  playerNode;
  constructor(
    openModalButton,
    modalNode,
    modalInnerNode,
    backdropNode,
    closeIconNode
  ) {
    this.openModalButton = openModalButton;
    this.modalNode = modalNode;
    this.modalInnerNode = modalInnerNode;
    this.backdropNode = backdropNode;
    this.closeIconNode = closeIconNode;
    this.modalName = this.openModalButton.getAttribute("data-name")
      ? this.openModalButton.getAttribute("data-name")
      : "";
    this.videoCode = this.openModalButton.getAttribute("data-code")
      ? this.openModalButton.getAttribute("data-code")
      : "";
    this.bindListeners();
  }

  bindListeners() {
    this.openModalButton.addEventListener("click", this.open.bind(this));
    this.backdropNode.addEventListener("click", this.close.bind(this));
    this.closeIconNode.addEventListener("click", this.close.bind(this));
    document.addEventListener('keydown', e =>{
      if(e.keyCode === 27 ){
        this.close();
      }
    })
    
    window.addEventListener('resize', () => {
      this.setSize();
    });
  }

  open() {
    this.modalInnerNode.innerHTML = '';
    this.playerNode = document.createElement('div');
    this.modalInnerNode.append(this.playerNode);
    let options = {
      id: this.videoCode,
      width: this.modalNode.clientWidth,
      height: this.modalNode.clientWidth * 9 / 16,
      controls: true,
      muted: false,
      background: false,
      autoplay: true,
      byline: false,
      title: false,
    };
    this.vimeoPlayer = new Player(this.playerNode, options);
    this.modalNode.setAttribute("data-name", this.modalName);
    this.modalNode.style.height = this.modalNode.clientWidth * 9 / 16 + 'px';
    this.modalNode.classList.add("open");
    this.backdropNode.classList.add("open");
  }

  close() {
      this.modalNode.classList.remove("open");
      this.backdropNode.classList.remove("open");
      this.modalInnerNode.innerHTML = "";

  }

  setSize() { 
    let iframe = this.modalNode.querySelector('iframe');
    if (iframe) { 
      iframe.style.width = this.modalNode.clientWidth + 'px'; 
      iframe.style.height = this.modalNode.clientWidth * 9 / 16 + 'px'; 
    }
    this.modalNode.style.height = this.modalNode.clientWidth * 9 / 16 + 'px'; 
  }
}



// WEBPACK FOOTER //
// ./ui/assets/js/Modal/ModalVideo.js